import { domainName, baseDomain, formattedDomainName } from 'utils/parseDomain'

const showRevisedText = strDomain =>
  ['marathishaadi.com', 'telugushaadi.com'].includes(strDomain)

const appTitle = strWord => {
  let title = ''
  switch (domainName) {
    case 'shaadi.com':
      title = 'Matrimony App to find matches'
      break
    case 'marathishaadi.com':
    case 'telugushaadi.com':
      title = `${strWord} Matrimony App by Shaadi.com`
      break
    default:
      title = `Matrimony App to find ${strWord} matches`
      break
  }
  return title
}

const appDomain = () =>
  showRevisedText(domainName) ? formattedDomainName : 'Shaadi.com'

const appBlockHeading = () =>
  showRevisedText(domainName)
    ? `Download the ${baseDomain} App`
    : 'Download the App'

const signUpSubText = strWord =>
  showRevisedText(domainName)
    ? `Register & create your free ${strWord} matrimony profile`
    : 'Register for free & put up your Profile'

export { appTitle, appDomain, appBlockHeading, signUpSubText }
